import saveFavoritesList from './save-favorites-list';

export { saveFavoritesList };

export default saveFavoritesList;
